import { Component, OnInit } from '@angular/core';
import { FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { GenerateCodeRequest } from '../models/generate-code-request';
import { LoaderService } from '../../../shared/services/loader.service';

@Component({
  selector: 'app-codigo-contrasena',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSnackBarModule,
  ],
  templateUrl: './codigo-contrasena.component.html',
  styleUrl: './codigo-contrasena.component.scss',
})
export class CodigoContrasenaComponent implements OnInit {
  codigo = new FormControl('', Validators.required);
  email = localStorage.getItem('email') ?? '';
  errorMensaje = '';
  isTenantMode = false;
  uuidClient: number = 0;

  constructor(
    private router: Router, 
    private authService: AuthService, 
    private loader: LoaderService,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.uuidClient = parseInt(params['uuidc'] == undefined ? 0 : params['uuidc']);
      if (this.uuidClient > 0) {
        localStorage.setItem('uuidClient', this.uuidClient.toString());
        this.isTenantMode = true;
      } else {
        const storedUuidClient = localStorage.getItem('uuidClient');
        if (storedUuidClient && parseInt(storedUuidClient) > 0) {
          this.isTenantMode = true;
        } else {
          this.isTenantMode = false;
        }
      }
    });
  }

  verificarCodigo() {
    if (this.codigo.invalid) {
      this.codigo.markAsTouched();
      return;
    }

    const payload = {
      identifier: {
        tenants: 'adff7f6a-e97d-11eb-9a03-0242ac130003',
        app: 'PortalAsistencia',
      },
      petition: {
        email: this.email,
        code: this.codigo.value ?? '',
      },
    };

    this.loader.show();

    this.authService.verifyCode(payload).subscribe({
      next: (res) => {
        this.loader.hide();
        if (res.code === 200) {
          localStorage.setItem('code', this.codigo.value ?? '');
          if (this.uuidClient > 0) {
            this.router.navigate(['/nuevacontrasena'], {
              queryParams: { uuidc: this.uuidClient }
            });
          } else {
            this.router.navigate(['/nuevacontrasena']);
          }
        } else {
          // código inválido
          this.codigo.setErrors({ invalid: true });
          this.errorMensaje = 'Código inválido. Intenta nuevamente.';
        }
      },
      error: (err) => {
        this.loader.hide();
        if (err.status === 409) {
          this.codigo.setErrors({ invalid: true });
          this.errorMensaje = 'Código inválido o expirado.';
        } else {
          console.error('Error inesperado:', err);
          this.errorMensaje = 'Ha ocurrido un error; intenta más tarde.';
        }
      },
    });
  }

  reenviarCodigo() {
    console.log('Reenviando código...');
    console.log(this.email);

    const payload: GenerateCodeRequest = {
            identifier: {
              tenants: 'adff7f6a-e97d-11eb-9a03-0242ac130003',
              app: 'PortalAsistencia',
            },
            petition: {
              email: this.email,
            },
          };
    this.loader.show();

    this.authService.generateCode(payload).subscribe({
      next: (res) => {
        this.loader.hide();
        if (res.success && res.code === 200) {
          this.snackBar.open('Nuevo código enviado exitosamente', 'Cerrar', {
            duration: 3000,
            horizontalPosition: 'center',
            verticalPosition: 'top'
          });
          //this.dialogRef.close();
        } else {
          //this.correoIncorrecto = true;
        }
      },
      error: (err) => {
        this.loader.hide();
        if (err.status === 403) {
          //this.correoIncorrecto = true;
        } else {
          console.error('Error inesperado:', err);
        }
      },
    });

  }

  goToNuevaContrasena() {
    if (this.uuidClient > 0) {
      this.router.navigate(['/nuevacontrasena'], {
        queryParams: { uuidc: this.uuidClient }
      });
    } else {
      this.router.navigate(['/nuevacontrasena']);
    }
  }
}
